<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
	<span class="relative">
		<img class="w-7 h-7 rounded-full" *ngIf="showAvatar && user.avatar" [src]="user.avatar">
		<mat-icon *ngIf="!showAvatar || !user.avatar" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
		<span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"></span>
	</span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
	<button mat-menu-item>
		<span class="flex flex-col leading-none">
			<span class="font-medium">{{user.firstName}} {{user.lastName}}</span>
			<span class="mt-1.5 text-sm text-secondary">{{user.email}}</span>
		</span>
	</button>


	<mat-divider class="my-2"></mat-divider>

	<button mat-menu-item (click)="changelog()">
		<div class="flex items-center w-full">
			<span>Frontend: <code>

				{{ version }}
			</code>
		</span>
		</div>
	</button>

	<button mat-menu-item (click)="changelog()">
		<div class="flex items-center w-full">
			<ng-container *ngIf="backendVersion$ | async as backendVersion; else loadingBackend">
				<span>Backend:
					<code>
						{{ backendVersion.version }}
					</code>
				</span>
			</ng-container>
			<ng-template #loadingBackend>
				<span>{{ 'user.backend-loading' | transloco }}</span>
			</ng-template>
		</div>
	</button>

	<mat-divider *ngIf="appService.networkStatus.value" class="my-2"></mat-divider>

	<!-- <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
        <span>Settings</span>
    </button>
    <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
        <span>Status</span>
    </button>
    <mat-divider class="my-2"></mat-divider>-->


	<button *ngIf="appService.networkStatus.value" mat-menu-item (click)="signOut()">
		<mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
		<span>{{ 'user.sign-out' | transloco }}</span>
	</button>

</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
	<button mat-menu-item (click)="updateUserStatus('online')">
		<span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
		<span>{{ 'user.online' | transloco }}</span>
	</button>
	<button mat-menu-item (click)="updateUserStatus('away')">
		<span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
		<span>{{ 'user.away' | transloco }}</span>
	</button>
	<button mat-menu-item (click)="updateUserStatus('busy')">
		<span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
		<span>{{ 'user.busy' | transloco }}</span>
	</button>
	<button mat-menu-item (click)="updateUserStatus('not-visible')">
		<span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
		<span>{{ 'user.invisible' | transloco }}</span>
	</button>
</mat-menu>
